export * from './fullscreen.directive';



// WEBPACK FOOTER //
// ./src/app/directives/fullscreen/index.ts